/**
 * What one bulk apply did to the rows that were ticked for it.
 *
 * The review dialog's equipment table and the plant register both run the same
 * offer — one set of values written to many ticked rows at once — and both
 * refuse the rows whose drawing does not define the asset. They report it in
 * one sentence from here so the two surfaces cannot come to word a skipped row
 * differently.
 */
export interface BulkApplyOutcome {
  /** Rows the drawing took every requested field for. */
  applied: number;
  /** Rows left alone because this drawing does not define the asset. */
  skipped: number;
  /** Rows refused because the record would then share its tag with another
   *  instrument. Counted apart from `failed` because the fix is different: the
   *  reviewer never typed the colliding tag, so the row is cleared by renaming
   *  one of the two records, not by running the bulk apply again. */
  duplicates: number;
  /** Rows that were sent and refused; each carries its reason on its own cell. */
  failed: number;
}

/** The action bar's report of a finished run. A skip is always stated. */
export function describeBulkApplyOutcome(outcome: BulkApplyOutcome): string {
  const parts = [`Applied to ${outcome.applied}`];
  if (outcome.skipped > 0) parts.push(`skipped ${outcome.skipped} (not primary)`);
  if (outcome.duplicates > 0) {
    parts.push(`${outcome.duplicates} duplicate ${outcome.duplicates === 1 ? 'tag' : 'tags'}`);
  }
  if (outcome.failed > 0) parts.push(`${outcome.failed} failed`);
  return parts.join(' · ');
}
